<usb-base-modal
  [title]="title"
  [subtitle]="subtitle"
  [confirmText]="confirmText"
  [cancelText]="cancelText"
  [showCancelButton]="showCancelButton"
  [size]="size"
  [titleReverse]="titleReverse"
  [icon]="icon"
>
  <div
    style="
      display: flex;
      flex-direction: column;
      gap: 10px;
      place-self: center;
      max-width: 220px;
    "
  >
    <h2
      class="m-0"
      style="
        font-size: 24px;
        font-weight: 600;
        font-family: 'Rubik';
      "
    >
      Eliminar
    </h2>
    <p
      class="m-0"
      style="
        font-size: 12px;
        font-weight: 400;
        font-family: 'Rubik';
      "
    >
      ¿Deseas eliminar este producto <br /> y realizar una nueva busqueda <br /> con los mismos datos?
    </p>
    <p
      style="
        font-size: 12px;
        font-weight: 400;
        font-family: 'Rubik';
        color: #c7c7c7;
      "
    >
      {{message}}
    </p>
  </div>
</usb-base-modal>
